import React, { Fragment, useState, useEffect, useCallback } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import profile01 from "../../../../images/profile/1.jpg";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import { CardTitle, CardBody } from "reactstrap";
import { connect } from "react-redux";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Row, Card, Col, Container, Badge } from "react-bootstrap";
import Button from "@material-ui/core/Button";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  GetOutletTimingList,
  saveOutletTiming,
  saveoutletDetails,
  updateletDetails,
  getoutletListMaster,
  getCompanyListMaster,
  SlotMasterList,
} from "../../../../apiservicescall/api";

import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";

import { useDispatch } from "react-redux";
/* import PageTitle from "../../../layouts/PageTitle"; */
//** Import Image */
/* import profile01 from "../../../../images/profile/1.jpg"; */
import profile02 from "../../../../images/profile/2.jpg";
import profile03 from "../../../../images/profile/3.jpg";
import profile04 from "../../../../images/profile/4.jpg";
import profile05 from "../../../../images/profile/5.jpg";
import profile06 from "../../../../images/profile/6.jpg";
import profile07 from "../../../../images/profile/7.jpg";
import profile08 from "../../../../images/profile/8.jpg";
import profile09 from "../../../../images/profile/9.jpg";
import profile from "../../../../images/profile/profile.png";
import img3 from "../../../../images/card/44.png";
import img6 from "../../../../images/card/img6.jpg";
import PageTitle from "../../../layouts/PageTitle";
import { setNestedObjectValues } from "formik";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { fetchProducts } from "../../../../services/AuthService";

import {
  useHistory,
  HashRouter as Router,
  useNavigate,
  Route,
  Switch,
  withRouter,
  Redirect,
} from "react-router-dom";

import {
  AMINTOMNR,
  RESET,
} from "../MasterManagment/EcommerMnagement/adminToMnagerActions";

const SuperAdminDashboard = (props) => {
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [replayModal, setReplayModal] = useState(false);
  const [popUpPageShow, setPopUpPageShow] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [editPageShow, setEditPageShow] = useState();
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [addFieldValue, setAddFieldValue] = useState();
  const [errors, setErrors] = useState({});
  const [addNewUserModal, setAddNewUserModal] = useState();
  const [PopupCommonStateTransfer, setPopupCommonStateTransfer] = useState();
  const [Outlettimeobj, setOutlettimeobj] = useState({});
  /* const [staffname,setStaffname]= useState(); */

  const [role, setRoll] = useState();

  const [restaurantDetails, setRestaurantDetails] = useState({
    menu: [
      { label: "Breakfast", value: "Breakfast" },
      { label: "Lunch", value: "Lunch" },
      { label: "Dinner", value: "Dinner" },
    ],
  });

  const [staffrole, setStaffrole] = useState([
    { label: "Manager", value: "Manager" },
    { label: "Staff", value: "Staff" },
    { label: "Others", value: "Others" },
  ]);

  const [staffdetails, setStaffdetails] = useState({
    staffid: "",
    staffimg: "",
    staffname: "",
    role: "",
    mobileno: "",
    emailid: "",
    statustype: "",
  });

  const [startTime, handleDateChange] = useState(new Date());
  const [endTime, handleTimeChange] = useState(new Date());

  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [slotmaster, setSlotmaster] = useState([]);

  const [timingslist, setTimingslist] = useState({
    outletCode: "",
    itemNo: "",
    dayName: "",
    dayId: "",
    dayStatus: "",
    slotId: "",
    startTime: "",
    endTime: "",
    slotFoodcty: "",
  });

  const [outlettiming, setOutlettiming] = useState({
    dayId: "",
    dayName: "",
    dayStatus: "",
    itemNo: "",
    outletCode: "",
    slottime: [
      {
        endTime: "",
        slotFoodcty: "",
        slotId: "",
        startTime: "",
      },
    ],
  });

  const [day, setDay] = useState([
    { label: "Monday", value: "Monday,1" },
    { label: "Tuesday", value: "Tuesday,2" },
    { label: "Wednesday", value: "Wednesday,3" },
    { label: "Thursday", value: "Thursday,4" },
    { label: "Friday", value: "Friday,5" },
    { label: "Saturday", value: "Saturday,6" },
    { label: "Sunday", value: "Sunday,7" },
  ]);

  const [dayName, setDayName] = useState({
    label: "",
    value: "",
  });

  const [menu, setMenu] = useState([
    { label: "Breakfast", value: "Breakfast" },
    { label: "Lunch", value: "Lunch" },
    { label: "Dinner", value: "Dinner" },
  ]);
  const [slotFoodcty, setSlotFoodcty] = useState([]);

  //stepper:
  const [activeStep, setActiveStep] = useState(0);
  const [popupModal, setPopupModal] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [contentModal, setContentModal] = useState(false);
  const [modalCentered, setModalCentered] = useState(false);
  const [modalWithTooltip, setModalWithTooltip] = useState(false);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [largeModal, setLargeModal] = useState(true);
  const [smallModal, setSmallModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [addtimemodal, setAddtimemodal] = useState();
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );
  const [selectedOutlet, handleSelectedOutlet] = useState({});
  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([
    {
      label: "",
      value: "",
    },
  ]);

  const [selectedOption, setSelectedOption] = useState({
    value: "",
    label: "",
  });

  // useCallback
  const getcompanyMasterList = useCallback(async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue", getoutletListValue)
    let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));
    setCompanyMaster(companyoutmaster);
    setOutletvalue({
      label: getoutletListValue[0]?.compName,
      value: getoutletListValue[0]?.compCode,
    });
  }, []);

  useEffect(() => {

    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let compCode = userDetails?.companyCode;
    getoutlettimeList(outletCode);
    getoutletList(compCode);
    getslotmaster(outletCode);
    getcompanyMasterList();
  }, [userDetails]);

  const getoutletList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data || [];

    console.log("getoutletList?.d", getoutletList?.data?.data);
    setOutletMasterlist(getoutletListValue);
  };

  const getoutlettimeList = async (outletCode) => {

    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data || [];
    setTimingslist(getoutletListValue);
    console.log("getoutletListValue", getoutletListValue);
  };

  const getslotmaster = async (outletCode) => {
    let getslotList = await SlotMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data || [];
    await setSlotmaster(getslotListValue);
    console.log("getslotListValue", getslotListValue);

    let tempslotMasteroutmaster = getslotListValue.map(
      ({ slotName, slotId }) => ({
        label: slotName,
        value: slotId,
      })
    );

    await setDropdownslotmaster(tempslotMasteroutmaster);
    console.log("tempslotMasteroutmaster", tempslotMasteroutmaster);
  };

  const savetiming = async () => {
    console.log("startTime", startTime);

    let startime24hourshr = new Date(startTime).getHours();
    let startime24hoursmi = new Date(startTime).getMinutes();
    let startTimefinalformat =
      startime24hourshr + ":" + startime24hoursmi + ":" + "00";
    console.log("startTimefinalformat", typeof startTimefinalformat);

    let endtime24hourshr = new Date(startTime).getHours();
    let endime24hoursmi = new Date(startTime).getMinutes();
    let endTimefinalformat =
      endtime24hourshr + ":" + endime24hoursmi + ":" + "00";
    console.log("endTimefinalformat", typeof endTimefinalformat);
    console.log("outlettiming?.dayId]", outlettiming?.dayName?.value);

    const values = outlettiming?.dayName?.value.split(",");

    let dayNameTrimmed = values[0].trim();
    let dayIdTrimmed = values[1].trim();
    console.log("dayNameTrimmed0]", dayNameTrimmed);
    console.log("dayIdTrimmed0]", dayIdTrimmed);

    let data = [
      {
        dayId: dayIdTrimmed || "",
        dayName: dayNameTrimmed || "",
        dayStatus: "true",
        itemNo: outlettiming?.itemNo || "",
        outletCode: "100001",
        slottime: [
          {
            endTime: endTimefinalformat || "",
            slotFoodcty: outlettiming?.slotFoodcty?.value || "",
            slotId: outlettiming?.slotId || "",
            startTime: startTimefinalformat || "",
          },
        ],
      },
    ];

    console.log("data", data);

    let reqforupload;
    if (isedit === false) {
      reqforupload = await saveOutletTiming(data);
    }
    if (reqforupload?.status === 200) {
      setOutlettiming({});
      setDayName({});
      setSlotFoodcty({});

      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      if (isedit === false) {
        swal("Success!", "Outlet Timing Created", "success");
      } else {
        swal("Success!", "Staff Details Updated", "success");
      }
      // await this.setState({ reload: false });
      // NotificationManager.success("Success");
      // this.setState({ addNewUserModal: false, loading: true });
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
    }
  };

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  //multiselect//
  const CustomClearText = () => "clear all";
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const onModalClose = () => {
    setAddtimemodal(!addtimemodal);
  };

  const addtiming = () => {
    setAddtimemodal(true);
  };

  const onChangeCommonpopup = (key, value) => {
    console.log("key", key);
    console.log("value", value);
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "dayName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["dayName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setDayName({
          ...value,
        });
        addFieldValue = { [key]: value };
        errorsLocal["dayName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "slotName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["slotName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {

        // let addFieldValuemaster = { ["slotId"]: value[0]?.value };
        console.log("addFieldValuemaster", typeof value);
        setSlotFoodcty([...value]);
        addFieldValue = { [key]: value };
        errorsLocal["slotName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...outlettiming };
    newFormData[key] = value;
    setOutlettiming(newFormData);
  };

  const handleChangetabl = (event, value) => {
    setActiveIndex(value);
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const onTimingUser = () => {
    setPopUpPageShow(true);
  };

  const DateChange = async (items) => {
    const newFormData = { ...outlettiming };
    newFormData["dayName"] = `${items.dayName}, ${items.dayId}`;
    setOutlettiming(newFormData);

    setDayName({
      label: items.dayName,
      value: items.dayId,
    });

    let selSlotTimes = items.slottime.map((stime) => {
      let selValue = {};
      selValue = dropdownslotmaster.filter(
        (mData) => mData.label == stime.slotName
      )[0];
      return selValue;
    });
    setSlotFoodcty(selSlotTimes);
    let selDay = {};
    if (items.dayName) {
      selDay = day.filter((d) => d.label == items.dayName)[0];
    }
    setDayName(selDay);
    setErrors({});
    setFormIsValid(true);
    setAddNewUserModal(true);
  };

  const onEditModalClose = () => {
    setEditPageShow(false);
  };

  return (
    <>
      <div className="mb-sm-2 d-flex flex-wrap align-items-center text-head row" style={{ backgroundColor: "#cccccc66", margin: "0px 1px", height: "8vh" }}>
        <div class="col-7">
          <h3 className="mb-3 me-auto" style={{ fontFamily: "Roboto", padding: "6px" }}>
            {largeModal === false ? selectedOutlet?.outletName : `  Outlets`}
          </h3>
        </div>
        <div class="col-3 col-sm-3 col-md-3 form-group" style={{ marginTop: "-20px" }}>
          <label as="a" variant="badge badge-rounded badge-danger">
            Company
          </label>
          <Select
            options={companyMaster}
            value={outletvalue}
            closeMenuOnSelect={false}
            search
            name="stateCode"
            placeholder="Choose"
            autoComplete="off"
            // isDisabled={isviewoutsid == "MANAGER" || isviewoutsid == "ADMIN"}
            onChange={(event) => {
              setOutletvalue(event);
              getoutletList(event?.value);
            }}
          />
          <br />
        </div>
        <div class="col-2 mb-3">
          {largeModal === false && (
            <button
              className="btn btn-primary dsh-out-btn"
              onClick={() => {
                setLargeModal(true);
                handleSelectedOutlet({});
              }}
            >
              {" "}
              Back{" "}
            </button>
          )}
        </div>
      </div>

      {/* <div class="col-sm col-md-4 form-group">
        <label as="a" variant="badge badge-rounded badge-danger">
          Company
        </label>
        <Select
          options={companyMaster}
          value={outletvalue}
          closeMenuOnSelect={false}
          search
          name="stateCode"
          placeholder="Choose"
          autoComplete="off"
          // isDisabled={isviewoutsid == "MANAGER" || isviewoutsid == "ADMIN"}
          onChange={(event) => {
            setOutletvalue(event);
            getoutletList(event?.value);
          }}
        />
        <br />
      </div> */}

      {largeModal === true ? (
        <div
          className="row dash-cards"
        // onClick={() => {
        //   setLargeModal(false);
        // }}
        >
          {" "}
          <br />
          {outletMasterlist &&
            outletMasterlist.map((items, key) => {


              return (
                <Col xl="3">
                  <Card
                    className="ds-mn-crd"
                    onClick={() => {

                      console.log("items?.outletCode", items?.outletCode);

                      setLargeModal(false);
                      handleSelectedOutlet(items);
                      getoutlettimeList(items?.outletCode);
                      getslotmaster(items?.outletCode);



                      // localStorage.setItem("admintomanger", JSON.stringify(`${items?.outletName} - ${items?.outletCode} - ${items?.compCode}`));
                      // window.location.replace('#/dashboard');
                      // window.location.reload(true);

                      // props.AMINTOMNR(items?.outletName, items?.outletCode, items?.compCode);
                      // <Redirect
                      //   to={{
                      //     pathname: "/dashboard",
                      //     state: { adminToMnr: items?.outletName - items?.outletCode - items?.outletCode },
                      //   }}
                      // />
                    }}
                  >
                    <Card.Header
                      style={{
                        backgroundColor:
                          items?.activeStatus === "A" ? "#0f590f" : "red",
                        padding: "6px", borderRadius: "4px"
                      }}
                    >
                      <Card.Title style={{ fontSize: "14px !important" }}> {items?.outletName} </Card.Title>
                      <i
                        onClick={() => {
                          handleSelectedOutlet(items);
                          localStorage.setItem(
                            "admintomanger",
                            JSON.stringify(
                              `${items?.outletName} - ${items?.outletCode} - ${items?.compCode}`
                            )
                          );
                          window.location.replace("#/dashboard");
                          window.location.reload(true);
                        }}
                        style={{ color: "white", fontSize: "large" }}
                        className="ti-eye dsh-icn-bck"
                      ></i>
                    </Card.Header>
                    <img style={{ borderRadius: "0px" }}
                      className="card-img-bottom img-fluid"
                      src={img3}
                      alt="Card cap"
                    />
                    <Card.Body style={{ padding: "4px" }}>
                      <Card.Text>
                        {items?.outletAddress} <br />
                        {items?.outletCity} {items?.outletState} <br />
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          {/* {outletMasterlist && outletMasterlist.length == 0 && <h4> Outlet Details Not found </h4>} */}
        </div>
      ) : (
        <>
          <div className="row outlet-info-cards ">
            <Col xl="4">
              <Card className="text-white bg-secondary" style={{ padding: "12px" }}>
                <Card.Header>
                  <Card.Title className="text-white">My Info</Card.Title>
                </Card.Header>
                <Card.Body className="mb-0">
                  <Card.Text style={{ fontSize: "medium" }}>
                    {selectedOutlet?.shortName} <br />
                    {selectedOutlet?.outletContactPerson} <br />
                    {selectedOutlet?.outletEmailId}
                    <br />
                    {selectedOutlet?.outletMobileNumber} <br />
                  </Card.Text>{" "}
                  <br /> <br />
                  <Card.Text style={{ fontSize: "medium" }}>
                    {selectedOutlet?.outletAddress} <br />
                    {selectedOutlet?.outletCity} <br />
                    {selectedOutlet?.outletState} <br />
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0"></Card.Footer>
              </Card>
            </Col>

            <Col xl="4">
              <Card className="text-white bg-secondary">
                <Card.Header>
                  <Card.Title className="text-white">Kyc Details</Card.Title>
                </Card.Header>
                <Card.Body className=" mb-0">
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        GST NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm sp-adm-ds-brd">
                      <Badge as="a" variant="primary badge-lg">
                        {" "}
                        {selectedOutlet?.outletGstNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        PAN NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm sp-adm-ds-brd-pn">
                      <Badge as="a" variant="secondary badge-lg">
                        {" "}
                        {selectedOutlet?.outletPanNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        FSSAI NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm  sp-adm-ds-brd-fss">
                      <Badge as="a" variant="danger badge-lg">
                        {" "}
                        {selectedOutlet?.outletFssaiRegNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        Bank AC NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm sp-adm-ds-brd-bnk">
                      <Badge as="a" variant="warning badge-lg">
                        {" "}
                        {selectedOutlet?.outletBankACNumber}
                      </Badge>
                    </div>{" "}
                    <br />
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xl="4">
              <Card className="text-white bg-secondary">
                <Card.Header>
                  <Card.Title className="text-white">
                    <div class="row">
                      <div class="col-10">
                      Timings
                      </div>
                      <div class="col-2">
                          
                    <span
                      style={{ paddingLeft: "190px" }}
                      className="icon-top-right"
                    >
                      <button
                        type="button"
                        className="rct-link-btn edit-btn"
                        onClick={() => onTimingUser()}
                      >
                        <i className="ti-pencil  tpen-bck-sad text-white"></i>
                      </button>
                    </span>
                      </div>

                    </div>
                   
                  </Card.Title>
                </Card.Header>

                <Card.Body className=" mb-0">
                  {timingslist.map((slot) => {
                    /*   */
                    console.log("timingslist", slot);
                    return (
                      <div className="row">
                        <div class="col-sm-12">
                          <Card.Text style={{ fontSize: "medium" }}>
                            {slot.dayName}
                          </Card.Text>
                        </div>
                        {slot.slottime.map((time) => {
                          return (
                            <div class="col-sm-5 mt-1 spr-adm-ds-out-badg">
                              {/* <Tippy content={time.slotFoodcty}> */}
                              <Badge
                                as="a"
                                variant="success badge-lg "
                                style={{
                                  backgroundcolor: " #0f590f",
                                  borderradius: "0px",
                                  color: "white"
                                }}
                              >
                                {" "}
                                {time.startTime} - {time.endTime}
                              </Badge>
                              {/* </Tippy> */}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </Card.Body>
              </Card>
            </Col>
          </div>
         
          <Modal
            isOpen={popUpPageShow}
            toggle={() => this.onAddUpdateUserModalClose()}
            /*  size={"lg"} */
            style={{ maxWidth: "1200px" }}
            backdrop="static"
          >
           
            <ModalHeader className="popup-header">
              Outlet Timings
              <span className="text-right popup-actions">
                <ul style={{display:"flex"}}>
                  <li> <Button
                  style={{
                    backgroundColor: "#0f590f",borderradius:"5px",
                    border:"0px #0f590f"
                  }}
                  className="btn btn-secondary "
                  onClick={() => addtiming()}
                >
                  Add Timing
                </Button></li>
                  <li>
                  <div className="close-btn-align">
                  <i
                    className="ti-close cls-icn"
                    onClick={onAddUpdateUserModalClose}
                    style={{
                      paddingTop: "10px",
                      color: "black",
                      fontSize: "medium",
                    }}
                  ></i>
                </div>
                  </li>
                </ul>
               
               
              </span>
            </ModalHeader>
            <ModalBody className="time-edit-con">
              <div className="row">
                {timingslist.map((items, index) => {
                  console.log("items", items);
                  return (
                    <Col xl="4" className="spr-adm-brd-tms-crd">
                      <Card className="text-white  times-card ">
                        <CardTitle className="text-white bg-secondary tme-crd-bck">
                          {items.dayName}
                          <span className="icon-top-right">
                            <button
                              type="button"
                              className="rct-link-btn edit-btn color-white text-white"
                              onClick={() => {
                                setIsedit(true);
                                DateChange(items);
                              }}
                            >
                              <i className="ti-pencil text-white dsh-icn-bck"></i>
                            </button>
                          </span>
                        </CardTitle>
                        <CardBody>
                          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
          label="Start Time"
          value={value}
           onChange={handleChange} \
          renderInput={(params) => <TextField {...params} />}
        />
        <br/>
        <TimePicker
          label="End Time"
          value={value}
           onChange={handleChange} 
          renderInput={(params) => <TextField {...params} />}
        />
                          </LocalizationProvider> */}


                          {items?.slottime.map((data) => {
                            // 
                            console.log("data", data);
                            return (
                              <div className="out-tim">
                                <div class="row">
                                  <div class="col-6">
                                    <div>
                                      <ul style={{display:"flex"}}>
                                        <li><button
                                          type="button"
                                          className="rct-link-btn edit-btn color-white text-white"
                                          onClick={() => {
                                            setIsedit(true);
                                            DateChange(items);
                                          }}
                                        >
                                          <i className="ti-time text-white dsh-icn-bck"></i>
                                        </button></li>
                                        <li>
                                          <h5>
                                            {data.slotName} :

                                          </h5></li>
                                      </ul>

                                    </div>
                                  </div>
                                  <div class="col-6 tme-sec-bdg">

                                    <div>
                                      <span className="badge badge-lg bg-green time-chip mr-2">
                                        {data.startTime} - {data.endTime}
                                        {/* <span className="icon-top-right">
                                    <button
                                      type="button"
                                      className="rct-link-btn edit-btn color-white text-white timing-edit"
                                      onClick={() => DateChange()}
                                      style={{
                                        paddingTop: "5px",
                                        paddingLeft: "8px",
                                      }}
                                    >
                                      <i className="ti-pencil text-white"></i>
                                    </button>
                                  </span> */}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
              </div>

              {/* <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
                <button
                  className="btn btn-primary btn-rounded me-3 mb-2"
                  onClick={onAddUpdateUserModalClose}
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div> */}
            </ModalBody>
          </Modal>
          
          <Modal
            isOpen={addNewUserModal}
            toggle={() => this.onAddUpdateUserModalClose()}
            /* size={"lg"} */
            style={{ maxWidth: "600px",display:"block",margin:"150px auto" }}
            backdrop="static"
          >
            <div className="cstm-mdl-hd">
            <ModalHeader>
              <div class="row">
                <div class="col-10">
                Update Time Slot
                </div>
                <div class="col-2" style={{textAlign:"end"}}>
                <i
                className="ti-close cls-icn"
                onClick={() => setAddNewUserModal(false)}
                style={{
                  
                }}
              ></i>
                </div>
              </div>
            
             
            </ModalHeader>

            <ModalBody>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div className="row">
                  <div class="col-sm col-md-5 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      {" "}
                      Day Name
                      <span class="text-warning">*</span>
                    </label>

                    <br />
                    <Select
                      options={day}
                      search
                      name="stateCode"
                      placeholder="Choose Dayname"
                      onChange={(event) => {
                        // 
                        onChangeCommonpopup("dayName", event);
                      }}
                      value={dayName}
                    />
                  </div>
                  <div class="col-sm col-md-5 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      {" "}
                      Category
                      <span class="text-warning">*</span>
                    </label>

                    <br />
                    <Select
                      /* isDisabled={true} */
                      options={dropdownslotmaster}
                      defaultValue={slotFoodcty}
                      isMulti
                      closeMenuOnSelect={false}
                      styles={{
                        clearIndicator: ClearIndicatorStyles,
                      }}
                      components={{ ClearIndicator }}
                      search
                      name="category"
                      placeholder="Choose Category"
                      onChange={(event) =>
                        onChangeCommonpopup("slotName", event)
                      }
                    />
                  </div>
                  <br />

                  {/*  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div class="col-sm col-md-5 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        {" "}
                        Start Time
                        <span class="text-warning">*</span>
                      </label>

                      <br />

                      <div style={{ width: "100px" }}>
                        <TimePicker
                          autoOk
                          placeholder="select starttime"
                          value={startTime}
                           onChange={handleDateChange} 
                          onChange={(event) => {
                            console.log("startTime", startTime);
                            handleDateChange(event, "startTime");
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm col-md-5 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        {" "}
                        End Time
                        <span class="text-warning">*</span>
                      </label>

                      <br />

                      <div style={{ width: "100px" }}>
                        <TimePicker
                          autoOk
                          placeholder="select endtime"
                          value={endTime}
                          onChange={(event) => {
                            console.log("endTime", endTime);
                            handleTimeChange(event, "endTime");
                          }}
                        />
                      </div>
                    </div>
                  </MuiPickersUtilsProvider> */}
                </div>
              </MuiPickersUtilsProvider>

              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
          label="Start Time"
          value={value}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} />}
        />
        <br/>
        <TimePicker
          label="End Time"
          value={value}
           onChange={handleChange} 
          renderInput={(params) => <TextField {...params} />}
        />
                          </LocalizationProvider> */}
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-primary foot-btn-sv me-3 mb-3"
              /*  onClick={onAddUpdateUserModalClose} */
              >
                {" "}
                Update{" "}
              </button>
            </ModalFooter>
            </div>
          </Modal>
        </>
      )}
      <Modal
        isOpen={addtimemodal}
        toggle={() => this.onAddUpdateUserModalClose()}
        /* size={"lg"} */
        style={{ maxWidth: "600px",display:"block",margin:"150px auto" }}
        backdrop="static"
      >
        <div className="cstm-mdl-hd">
        <ModalHeader>Add Timings</ModalHeader>
        <ModalBody>
          <div className="row">
            <div class="col-sm col-md-5 form-group">
              <label as="a" variant="badge badge-rounded badge-danger">
                {" "}
                Day Name
                <span class="text-warning">*</span>
              </label>

              <br />
              <Select
                options={day}
                value={dayName}
                search
                name="dayname"
                placeholder="Choose Dayname"
                onChange={(event) => onChangeCommonpopup("dayName", event)}
              />
            </div>
            <div class="col-sm col-md-5 form-group">
              <label as="a" variant="badge badge-rounded badge-danger">
                {" "}
                Category
                <span class="text-warning">*</span>
              </label>

              <br />
              <Select
                options={dropdownslotmaster}
                Value={slotFoodcty}
                isMulti
                closeMenuOnSelect={false}
                components={{ ClearIndicator }}
                styles={{
                  clearIndicator: ClearIndicatorStyles,
                }}
                /* isDisabled={true} */
                name="category"
                placeholder="Choose Category"
                onChange={(event) => onChangeCommonpopup("slotName", event)}
              />
            </div>
            <br />

            {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div class="col-sm col-md-5 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  {" "}
                  Start Time
                  <span class="text-warning">*</span>
                </label>

                <br />

                <div style={{ width: "100px" }}>
                  <TimePicker
                    autoOk
                    placeholder="select starttime"
                    value={startTime}
                     onChange={handleDateChange} 
                    onChange={(event) => {
                      console.log("startTime", startTime);
                      handleDateChange(event, "date");
                    }}
                  />
                </div>
              </div>
              <div class="col-sm col-md-5 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  {" "}
                  End Time
                  <span class="text-warning">*</span>
                </label>

                <br />

                <div style={{ width: "100px" }}>
                  <TimePicker
                    autoOk
                    placeholder="select endtime"
                    value={endTime}
                    onChange={(event) => {
                      console.log("endTime", endTime);
                      handleTimeChange(event, "date");
                    }}

                   onChange={(event) => {
                    console.log("endTime", endTime);
                    handleTimeChange(event, "endTime");
                  }}
                  />
                </div>
              </div>
            </MuiPickersUtilsProvider> */}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary foot-btn-sv me-3 mb-3"
            onClick={() => {
              console.log("outlettiming", outlettiming);
              savetiming();
            }}
          >
            {" "}
            Save{" "}
          </button>

          <button
            className="btn btn-danger foot-btn-cls me-3 mb-3"
            onClick={() => onModalClose(false)}
          >
            {" "}
            Close{" "}
          </button>
        </ModalFooter>
        </div>
      </Modal>
    </>
  );
};

// export default SuperAdminDashboard;

const mapStateToProps = (state) => {

  console.log("state", state);
  return {
    outletName: state.adminToMnager.outletName,
    outletId: state.adminToMnager.outletId,
    companyCode: state.adminToMnager.companyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AMINTOMNR: (outletName, outletId, companyCode) => {

      dispatch(AMINTOMNR(outletName, outletId, companyCode));
    },
    RESET: (outletName, outletId, companyCode) => {
      dispatch(RESET(outletName, outletId, companyCode));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperAdminDashboard);

{
  /* <div className="row dash-cards"> */
}

{
  /* </div> */
}
